<template>
  <st-scrolly class="scrolly-story" :windowHeight="$window.innerHeight" :style="scrollyHasHeader ? fadeoutScrollyStyle : 1">
    <template v-slot:background="{progress, slideIndex}">
      <div :setvar="currentslideIndex=slideIndex"></div>
      <component v-for="({type, value}, i) in attributes.value" :key="i" :is="type"
        v-if="i >= slideIndex - 2 && i <= slideIndex + 2"
        :attributes="value"
        :progress="progress.at(i)()"
        :slidenum="i"
        :slideIndex="slideIndex"
        @changeaspectratio="setaspectratio"
        :style="{opacity: i <= slideIndex && i > slideIndex - 5 || i === 0 ? 1 : 0, zIndex: i === slideIndex ? 2 : 0}"
        >
      </component>
      <ai2html v-for="({type, value}, i) in attributes.value" :key="'k'+i"
        v-if="value && value.ai2htmlsrc"
        :attributes="value"
        :aspectRatio=aspectRatio
        :style="{zIndex: 2}"
        v-show="i === slideIndex"
        >
      </ai2html>
      <!-- <video :class="['intro-video', {'slide-1': progress.at(1)() < .30 && slideIndex === 1}]"
        muted
        preload="auto"
        autobuffer
        playsinline
        autoplay
        loop
        ref="video">
        <source :src="getVideoSource(attributes.value)" type="video/mp4">
      </video> -->

      <div class="minimap-container" v-if="attributes.value[slideIndex] && attributes.value[slideIndex].value.minimapfolder">
        <st-get-svg
          :root-folder="attributes.value[slideIndex].value.minimapfolder"
          :platform="platform">
        </st-get-svg>
      </div>

      <div class="topmap-container" v-if="attributes.value[slideIndex] && attributes.value[slideIndex].value.topmapfolder">
        <st-get-svg
          :root-folder="attributes.value[slideIndex].value.topmapfolder"
          :platform="platform">
        </st-get-svg>
      </div>
    </template>

    <div :class="slideContentClass(deckimage || deckimageslides || deckimagesarr)" :style="slideContentStyle(i)" v-for="({value: {deck, deckimage, deckimageslides, inlineimage, header, title, iconimage, id, sectiontitle, sectiondeck, introdeck, deckimagesarr, paywall}}, i) in attributes.value" :key="i">
      <div v-if="parseInt(header)" class="content-header">
        <st-header :header="header" class="custom-header"></st-header>
        <scrollDown />
      </div>
      <div class="content-intro" v-show="introdeck">
        <h3 v-markdown="introdeck"></h3>
      </div>
      <div class="content-section-intro" v-if="sectiontitle || sectiondeck" :id="id">
        <div>
          <img class="icon-image" v-if="iconimage" :src="require(`images/${iconimage}`)" alt="image"/>
          <h2 v-if="sectiontitle" v-markdown="sectiontitle"></h2>
          <p v-if="sectiondeck" v-markdown="sectiondeck"></p>
        </div>
      </div>
      <div v-if="title || deck || inlineimage" :class="['content-wrapper']" :id="id">
        <img class="icon-image" v-if="iconimage" :src="require(`images/${iconimage}`)" alt="image"/>
        <h3 v-if="title" v-markdown="title"></h3>
        <p v-if="deck" v-markdown="deck"></p>
        <img class="inline-image" v-if="inlineimage" :src="getSource(inlineimage)" alt="image">
      </div>
      <img v-if="deckimage" class="deck-image"  :src="getSource(deckimage)" alt="image">
      <img v-else-if="deckimageslides" class="deck-image"  v-for="(deckimg, i) in deckimageslides" :key="i" :src="getSource(deckimg)" alt="image">
      <template v-if="deckimagesarr">
        <figure class="deck-image" v-for="(deckimg, i) in deckimagesarr" :key="i">
          <img :src="getSource(deckimg.src)" alt="image">
          <figcaption v-if="deckimg.caption" v-markdown="deckimg.caption"></figcaption>
        </figure>
      </template>
      <login-widget class="login-incomponent" v-if="parseInt(paywall)"/>
    </div>
  </st-scrolly>
</template>

<script>
// import StScrolly from "../Scrolly/index.vue";
import StScrolly from "@st-graphics/scrolly";
import "@st-graphics/scrolly/dist/bundle.css";
import StGetSvg from "./../SvgFolder/StGetSvg.vue";
import videoslide from "./VideoSlide/index.vue";
import ai2html from "./ai2html/index.vue";
import imageslide from "./ImageSlide.vue";
import StHeader from "../../main/header/st-header.vue";
import scrollDown from "../scroll-down.vue";
import LoginWidget from '../LoginWidget.vue'

export default {
  props: ["attributes"],
  components: {
    StScrolly,
    StGetSvg,
    videoslide,
    imageslide,
    StHeader,
    scrollDown,
    LoginWidget,
    ai2html
  },
  data() {
    return {
      initHeight: this.$window.innerHeight,
      loaded: 0,
      currentslideIndex: -1,
      aspectRatio: 1
    }
  },
  watch: {
    currentslideIndex (newVal, oldVal) {
      if (!this.attributes.class || !this.attributes.class.includes('intro-scrolly')) {
        if (newVal >= 0 && newVal < this.attributes.value.length) {
          this.$el.querySelector('.st-scrolly .background-container').style.position = 'fixed'
        } else {
          this.$el.querySelector('.st-scrolly .background-container').style.position = 'absolute'
        }
      }
    }
  },
  computed: {
    platform() {
      return this.isTabletWidth ? "mobile" : "desktop";
    },
    isTabletWidth() {
      return this.$window.innerWidth < 768;
    },
    targetFullHeight() {
      return this.isTabletWidth ? this.initHeight : this.$window.innerHeight;
    },
    scrollY(){
      return this.$window.scrollY
    },
    scrollyHasHeader (){
     return !!this.attributes.value[0].value.header
    },
    nSlide () {
      return this.attributes.value.length
    },
    fadeoutScrollyStyle (){
      const opacity = this.scrollY < this.$window.innerHeight * this.nSlide ? 1 : -(this.scrollY/this.$window.innerHeight) + this.nSlide + 1
      return { opacity }
    },
  },
  methods: {
    slideContentClass(deckimage) {
      return {
        "slide": true,
        "slide-content": true,
        fullscreen: deckimage,
      };
    },
    slideContentStyle(i) {
      const isFirstSlide = i === 0;
      return {
        paddingTop: isFirstSlide ? `${this.targetFullHeight}px` : 0, // need to add additional trigger offset for st-scrolly
        // paddingTop: `${this.targetFullHeight}px`, // need to add additional trigger offset for st-scrolly
        paddingBottom: `${this.targetFullHeight}px`,
        // paddingBottom: `${this.targetFullHeight * (isFirstSlide ? 1 : 2)}px`
      };
    },
    getSource(value) {
      const { isTabletWidth } = this;
      let [path, ext = "jpg"] = value.split(".");
      path += (!isTabletWidth ? "-desktop." : ".") + ext;
      return require(`images/${path}`);
    },
    getVideoSource(val) {
      if (!val) return;
      var src = val[0].value.src;
      const [path, ext] = src.split(".");
      return require(`videos/${path}-desktop.${ext}`);
    },
    isMobile() {
      return /Android|iPhone|iPad|iPod|BlackBerry/i.test(
        navigator.userAgent || navigator.vendor || window.opera
      );
    },
    setaspectratio (val) {
      this.aspectRatio = val
    }
  },
  mounted () {
    // if (this.isMobile()) {
    //   // force auto play intro video on low battery mode on mobile
    //   const vid = this.$el.querySelector("video.intro-video");
    //   var events = ["click", "touchstart"];
    //   for (let i in events) {
    //     document.addEventListener(events[i], function(ev) {
    //       if (
    //         vid.autoplay &&
    //         vid.currentTime > 0 &&
    //         !vid.paused &&
    //         !vid.ended &&
    //         vid.readyState > 2
    //       ) {
    //         // is playing don't do anything
    //       } else {
    //         vid.play()
    //         vid.controls = false
    //         vid.removeAttribute('controls')
    //       }
    //     });
    //   }
    // }
  },
};
</script>

<style lang="scss">
.component.component-scrollystory {
  padding: 0 !important;
  margin-top: -50px;
}

.scrolly-story.st-scrolly {
  .background-container {
    /* background-color: #000000; */
    background-color: transparent;
  }

  .background {
    max-width: none;

    & > * {
      transition: opacity 0s; // remove opacity cuz trying only vidoe slides
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: 100%;
      height: 100%;

      &.video-slide,
      &.image-slide {
        /* background-color: #000000; */
        background-color: transparent;
      }

      // &.video-slide {
      //   position: fixed;
      //   top: 50%;
      //   bottom: 50%;
      // }

      &.minimap-container,
      &.topmap-container {
        opacity: 0;
        animation: fadeMap 1s 0.5s forwards;
        z-index: 2;
        position: absolute;
        right: 10px;
        transform: translate(0, -50%);
        left: auto;
        width: 150px;
        height: 150px;

        @include breakpoint($d_medium) {
          width: 200px;
          height: 200px;
        }

        & > .st-svg {
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }

      &.topmap-container {
        top: 10px;
        transform: translate(0, 0);

        width: 100px;
        height: 100px;

        @include breakpoint($d_normal) {
          width: 120px;
          height: 120px;
        }
      }
    }
  }

  .slide-container {
    max-width: none;
    // background-color: rgba(255, 255, 255, 0.35); // temporarily add to make the contrast between mockup and texts visible

    .slide-content {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: border-box;

      &:first-of-type {
        padding-top: 100vh; // need to add additional trigger offset
      }
      img.inline-image {
        width: 100%;
        vertical-align: bottom;
        padding-top: 10px;
      }

      &:not(.fullscreen) {
        max-width: 1200px;
        margin: 0 auto;
        padding-left: 10px;
        padding-right: 10px;
      }

      // .intro-photo-crop {
      //   position: absolute;
      //   top: 70%;
      //   left: 50%;
      //   transform: translate(-50%, -50%);
      //   border: 7px solid #fff;
      //   box-shadow: 1px 1px 8px rgba(#000, 0.7);
      //   overflow: hidden;
      //   margin: 0;

      //   img {
      //     position: absolute;
      //     top: 50%;
      //     left: 50%;
      //     transform: translate(-50%, -50%);
      //     width: 100vw;
      //     height: auto;
      //     object-fit: cover;
      //     object-position: center;
      //   }

      //   @include breakpoint($d_medium) {
      //     margin: 0;
      //   }
      // }

      .content-intro {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);

        text-align: center;
        width: 100%;
        margin: 0 auto;
        padding: 20px;
        border-radius: 3px;
        box-sizing: border-box;

        h3 {
          font-size: 28px;
          line-height: 1.4em;
          color: #fff;
          text-shadow: 0 0 1rem #00000044, 0 0 .6rem #00000088, 0 0 .3rem #000000CC;
        }

        mark {
          text-shadow: none;
        }

        @include breakpoint($d_medium) {
          max-width: 700px;

          h3 {
            font-size: 34px;
          }
        }
      }

      // &:nth-child(1) {
      //   .content-intro {
      //     h3 {
      //       font-size: 28px;
      //       line-height: 34px;
      //       color: #333;

      //       mark {
      //         font-size: 1.15em;
      //         line-height: 1.15em;
      //         color: #fff;
      //       }
      //     }

      //     @include breakpoint($d_medium) {
      //       max-width: 700px;

      //       h3 {
      //         font-size: 36px;
      //         line-height: 48px;
      //       }
      //     }
      //   }
      // }

      .content-section-intro {
        text-align: left;
        padding: 0 20px;

        @include breakpoint($d_medium) {
          max-width: 400px;
        }

        div {
          width: 100%;
          text-align: left;

          img.icon-image {
            width: 120px;
            height: 120px;
          }

          h2 {
            padding-top: 20px;
            font-size: 32px;
            line-height: 1.1em;
            margin-bottom: 20px;
          }

          p {
            font-family: $font-SelaneTextRegular;
            font-size: 20px;
            line-height: 1.3em;
          }

          h2, p {
            color: #000;
            text-shadow: 0px 0px 2px #fff;
          }

          &.darkmode {
            h2, p {
              color: #fff;
              text-shadow: 0 0 1rem #00000044, 0 0 .6rem #00000088, 0 0 .3rem #000000CC;
            }
          }
        }
      }

      .content-wrapper {
        background-color: rgba(white, 0.75);
        // padding: 20px;

        @include breakpoint($d_medium) {
          max-width: 400px;
        }

        img.icon-image {
          padding: 20px 0 0 20px;
          margin-bottom: -20px;
          width: 60px;
          height: 60px;
        }

        h3 {
          padding: 20px 0 0 20px;
        }

        p {
          // color: $black !important;
          color: $black;
          // padding: 20px 20px 0; // all inline images were placed semi-fullwidth so no need for padding-bottom:0
          padding: 20px;

          // &:only-child {
          //   padding: 20px;
          // }

          @include breakpoint($d_medium) {
            font-size: 22px;
          }

          strong,
          i {
            color: $black !important;
          }
        }

        &.darkmode {
          background-color: rgba(#000, 0.75);

            h2, h3, h4, h5, p {
              color: #fff;
              // text-shadow: 0px 0px 2px #000;
            }
          }
      }

      & > img.deck-image {
        width: 100%;
        margin-top: -8px;

        @supports (object-fit: cover) {
          height: 100vh;
          object-fit: cover;
        }
      }

      & > figure {
        padding: 20px;
        box-sizing: border-box;

        img.deck-image {
          width: 100%;
          margin-top: -8px;

          @supports (object-fit: cover) {
            height: 100vh;
            object-fit: cover;
          }
        }

        figcaption {
          color: #fff;
          text-shadow: 0 0 10px #000000, 0 0 5px #00000066, 0 0 3px #000000CC;
        }

        @include breakpoint($d_small) {
          padding: 4rem;
        }
      }
    }
  }
}

@keyframes fadeMap {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.scrolly-story.st-scrolly {
  .slide-container {
    .slide-content:first-child {
      // background-image: linear-gradient(
      //   to bottom,
      //   rgba(255, 255, 255, 1),
      //   rgba(255, 255, 255, 0.65),
      //   rgba(255, 255, 255, 0)
      // );
      // max-width: unset;
      // padding-top: 0px !important;
      margin-bottom: 50vh !important;
      .content-header {
        // max-width: 1440px;
        // margin: 0 auto;
        position: relative;
        height: 100vh;
        // width: 100%;
        // top: 50%;
        // left: 0%;
        // position: absolute;
        // transform: translate(-50%, -50%);
        .main-headline h1,
        .st-deck p,
        .st-byline {
          // color: #000;
          color: #fff;
          text-shadow: 1px 1px 3px #000;

          a {
            color: white;
            text-decoration: underline;
            text-decoration-color: #fff;
            text-decoration-style: dotted;
          }
        }
        .scroll_down[data-v-10175718] {
          position: relative !important;
          padding-top: 250px;
          // bottom: unset;
          // position: absolute;
          // bottom: 50px;
          // left: 50%;
          // transform: translate(-50%, 0);
        }
        .custom-header {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: auto;
        }
      }
    }
    .slide-content:last-child {
      margin-bottom: 50vh;
      margin-left: 0;
      margin-right: 0;
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;

      .content-wrapper {
        margin-left: 10px;
        margin-right: 10px;
        max-width: 100%;

        @include breakpoint($d_medium){
          max-width: 400px;
        }

        @include breakpoint($d_large){
          margin-left: calc((100vw - 1200px)/2);
        }
      }
    }
  }
  .background-container .background {
    .intro-video {
      z-index: 2;
      object-fit: cover;
      opacity: 0;
      transition: opacity 1s ease-in-out;
      &.slide-1 {
        opacity: 1;
      }
      &::-webkit-media-controls {
        display: none !important;
        opacity: 0 !important
      }
    }
  }
}
</style>
